export default "__VITE_ASSET__Bsq9LuRE__"